import { ValidatorFn, Validators } from '@angular/forms';
import { CustomValidator } from '@helpers/custom-validator';

export const addressValidation: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required, Validators.maxLength(32)] },
      { key: 'line2', validators: [] },
      { key: 'line3', validators: [] },
    ],
  },
];

export const iorContactFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'isImporterOfRecord', validators: [] },
  {
    key: 'importerOfRecordContactInformation',
    validators: [],
    children: [
      { key: 'firstName', validators: [Validators.required] },
      { key: 'lastName', validators: [Validators.required] },
      { key: 'phoneNumber', validators: [Validators.required] },
      { key: 'emailAddress', validators: [Validators.required, Validators.email] },
    ],
  },
];

export const iorContactValidation: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  {
    key: 'importerOfRecordContactInformation',
    validators: [],
    children: [
      { key: 'firstName', validators: [Validators.required] },
      { key: 'lastName', validators: [Validators.required] },
      { key: 'phoneNumber', validators: [Validators.required] },
      { key: 'emailAddress', validators: [Validators.required, Validators.email] },
    ],
  },
];

// FIELDS TO VALIDATE FORM
export const isfValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactValidation,
];

export const bondsValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const lclNonAllowCustomsValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const lclValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const esValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'authorizationAgreementAccepted', validators: [] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const fullCompanyFormKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

// FIELDS TO CREATE FORM
export const lclFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifierQualifier', validators: [] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactFormFields,
  // !!!
  { key: 'dateOfBirth', validators: [] },
  { key: 'businessType', validators: [] },
  { key: 'identifier', validators: [] },
  { key: 'isLockedIdentifier', validators: [] },
  { key: 'validationDate', validators: [] },
];

export const cbpAssignedNumberRequestFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  // #13233 — State of Incorporation carried by the CBP-request sidebar form
  { key: 'stateOfIncorporation', validators: [] },
  { key: 'authorizationAgreementAccepted', validators: [] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactFormFields,
  { key: 'isLockedIdentifier', validators: [] },
  { key: 'payerUnitNumber', validators: [Validators.minLength(6), Validators.maxLength(6)] },
  { key: 'dateOfBirth', validators: [] },
  { key: 'validationDate', validators: [] },
];

export const esFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'authorizationAgreementAccepted', validators: [] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactFormFields,
  { key: 'isLockedIdentifier', validators: [] },
  // { key: 'paymentType', validators: [Validators.required] },

  // !!!
  { key: 'payerUnitNumber', validators: [Validators.minLength(6), Validators.maxLength(6)] },
  { key: 'dateOfBirth', validators: [] },
  { key: 'validationDate', validators: [] },
];

export const isfFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactFormFields,
  { key: 'isLockedIdentifier', validators: [] },
  // !!!
  { key: 'dateOfBirth', validators: [] },
  { key: 'validationDate', validators: [] },
];

export const bondsFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  { key: 'phone', validators: [Validators.required] },
  ...addressValidation,
  ...iorContactFormFields,
  { key: 'isLockedIdentifier', validators: [] },

  // !!!
  { key: 'dateOfBirth', validators: [] },
  { key: 'validationDate', validators: [] },
];

export const fullCompanyFormFields: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'id', validators: [] },
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [] },
  { key: 'identifierQualifier', validators: [] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [] },
  // #13188 — State of Incorporation; required validator applied dynamically in edit-company
  { key: 'stateOfIncorporation', validators: [] },
  { key: 'authorizationAgreementAccepted', validators: [] },
  { key: 'isAllowedRegistration', validators: [] },
  {
    key: 'address',
    validators: [],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [Validators.required] },
      { key: 'line1', validators: [Validators.required, Validators.maxLength(32)] },
      { key: 'line2', validators: [] },
      { key: 'line3', validators: [] },
    ],
  },

  { key: 'isUnitedStates', validators: [] },
  { key: 'activity', validators: [] },
  { key: 'logoUri', validators: [] },
  { key: 'isLockedIdentifier', validators: [] },
  // !!!
  { key: 'payerUnitNumber', validators: [Validators.minLength(6), Validators.maxLength(6)] },
  { key: 'dateOfBirth', validators: [] },
  { key: 'validationDate', validators: [] },
  ...iorContactFormFields,
];

// FIELDS TO VALIDATE FORM BY VIEW FIELDS
export const lclSideBarValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'identifierQualifier', validators: [] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  { key: 'businessType', validators: [] },
  { key: 'identifier', validators: [] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const esSideBarValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'authorizationAgreementAccepted', validators: [] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
  // { key: 'paymentType', validators: [Validators.required] },
];

export const isfSideBarValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [Validators.requiredTrue] },
  { key: 'phone', validators: [Validators.required] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const bondsSideBarValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  { key: 'isAllowedRegistration', validators: [] },
  {
    key: 'address',
    validators: [Validators.required],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [CustomValidator.stateIsRequired()] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
  ...iorContactValidation,
];

export const fullCompanyValidationKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'isUnitedStates', validators: [] },
  { key: 'shippingRole', validators: [] },
  { key: 'identifier', validators: [] },
  { key: 'identifierQualifier', validators: [] },
  { key: 'businessName', validators: [] },
  { key: 'businessType', validators: [] },
  { key: 'isAllowedRegistration', validators: [] },
  {
    key: 'address',
    validators: [],
    children: [
      { key: 'city', validators: [] },
      { key: 'country', validators: [] },
      { key: 'postalCode', validators: [Validators.maxLength(9)] },
      { key: 'state', validators: [] },
      { key: 'line1', validators: [] },
    ],
  },
  // { key: 'paymentType', validators: [] },
];

//FIELDS TO VALIDATE CHANGES TO THE COMPANY WHICH HAS VALIDATION DATE

export const usCompanyChangesKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'identifier', validators: [Validators.required] },
  { key: 'identifierQualifier', validators: [Validators.required] },
  { key: 'businessName', validators: [Validators.required] },
  { key: 'businessType', validators: [Validators.required] },
  {
    key: 'address',
    validators: [],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [Validators.required] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
];

export const nonUsCompanyChangesKeys: Array<{ key: string; validators: ValidatorFn[]; children?: any }> = [
  { key: 'businessName', validators: [Validators.required] },
  {
    key: 'address',
    validators: [],
    children: [
      { key: 'city', validators: [Validators.required] },
      { key: 'country', validators: [Validators.required] },
      { key: 'postalCode', validators: [Validators.required, Validators.maxLength(9)] },
      { key: 'state', validators: [Validators.required] },
      { key: 'line1', validators: [Validators.required] },
    ],
  },
];
